import React, {useEffect, useState} from "react"
import Appbar from "./Appbar";
import Box from "@mui/material/Box";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import axios from "axios";
import FinancialChart from "./Chart/FinancialChart";
const FinancialReports = ({isMobile}) => {
    const [loading , setLoading] = useState(false);
    const [report , setReport] = useState([]);
    useEffect(()=>{
        const data={
            token : localStorage.getItem("token"),
        }
        axios.post("https://app.zhivay.com/api/get_financialreport.php",data)
            .then(response=>{
                setReport(response.data);
                console.log(response.data);
            })
            .catch(error=>{

            })
    },[])

    return (
        <div style={{width: !isMobile ? "calc(100% - 240px)" : ""}}>
            <Appbar isMobile={isMobile}/>
            <Box sx={{padding: 2}} dir={"rtl"}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={5} sm={12}>
                        <Box sx={{backgroundColor: "#e8e8e8", borderRadius: "7px"}}>
                            <Box id={"title"} sx={{textAlign: "center"}}>
                            </Box>
                            <Box sx={{padding:2}}>
                                <p>سال مالی : <span style={{fontWeight:"bold"}}>{report.year}</span></p>
                                <p>فروش کل : <span style={{fontWeight:"bold"}}>{report.totalprice}</span></p>
                                <Typography>
                                    جزئیات فروش
                                </Typography>
                                <div style={{marginRight:"15px",fontSize:"14px"}}>
                                    <p>
                                        پروفیل آهن : <span style={{fontWeight:"bold"}}>{report.profilAhan}</span>
                                    </p>
                                    <p>
                                        رنگ : <span style={{fontWeight:"bold"}}>{report.rang}</span>
                                    </p>
                                    <p>
                                        اجرت نصب : <span style={{fontWeight:"bold"}}>{report.nasb}</span>
                                    </p>
                                </div>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7} sm={12}>
                        <Box sx={{backgroundColor: "#e8e8e8", borderRadius: "7px"}}>
                            <Box id={"title"} sx={{textAlign: "center",paddingTop:1}}>
                                <FinancialChart series={report.chartdata} />
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Box>

        </div>
    )
}
export default FinancialReports;